import { MEASUREMENT_CALCULATION_TYPE_TOTAL_COUNT } from '../../../constants/measurement-calculation-types';

export const isTotalCountMeasurement = calculationId => {
  return calculationId === MEASUREMENT_CALCULATION_TYPE_TOTAL_COUNT;
};
